import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  createHttpLink,
} from "@apollo/client";
import { loadDevMessages, loadErrorMessages } from "@apollo/client/dev";
import { onError } from "@apollo/client/link/error";
import { isProductionEnvironment } from "mt-shared/environment";

export default function createApolloClient() {
  const getToken = () => {
    const localStorageUser = localStorage.getItem("user");
    const user = localStorageUser ? JSON.parse(localStorageUser) : null;
    return user ? `Bearer ${user.token}` : "";
  };

  const authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        authorization: getToken(),
        "Apollo-Require-Preflight": "true",
      },
    });
    return forward(operation);
  });

  const httpLink = createHttpLink({
    uri: `${import.meta.env.VITE_API_URL}/graphql`,
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      for (const err of graphQLErrors) {
        console.error(
          `[GraphQL error]: Message: ${err.message}, Location: ${err.locations}, Path: ${err.path}`
        );
        if (err.extensions?.code === "UNAUTHENTICATED") {
          localStorage.removeItem("user");
          if (window === undefined) continue;
          window.location.href = `/login`;
        }
      }
    }
    if (networkError) console.error(`[Network error]: ${networkError}`);
  });

  if (!isProductionEnvironment) {
    loadDevMessages();
    loadErrorMessages();
  }

  return new ApolloClient({
    cache: new InMemoryCache({
      addTypename: false,
    }),
    link: ApolloLink.from([errorLink, authMiddleware, httpLink]),
  });
}
